import { useState } from "react";
import { GlobalAuthFetch } from "../../Utils/GlobalAuthFetch/GlobalAuthFetch";

export const useContacts = () => {
  const [contacts, setContacts] = useState([]);

  const getContactData = async (searchTerm) => {
    if (!searchTerm?.length) return [];

    const payload = await GlobalAuthFetch({
      path: `/contact/findByName/${searchTerm}`,
    });

    const list =
      payload?.payload?.data?.map((contact) => ({
        uuid: contact.uuid,
        value: contact.name,
        ...contact,
      })) || [];

    setContacts(list);
    return list;
  };

  return {
    contacts,
    getContactData,
  };
};
